module.exports = __webpack_public_path__ + "static/media/9.736b5520.jpg";